import { render, staticRenderFns } from "./BasicTable.vue?vue&type=template&id=ca6847d2"
import script from "./BasicTable.vue?vue&type=script&lang=ts"
export * from "./BasicTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports